import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Link } from '@mui/material';

/**
 * A link to an external location
 */
var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement(Link, _extends({
    target: "_blank",
    rel: "noopener noreferrer"
  }, props));
};

var ExternalLink$1 = ExternalLink;

export { ExternalLink$1 as default };
